const normalize = (value) => String(value || "").trim().toLowerCase();

export function isOperationalAnimalField(field, species) {
    if (field?.active === false || field?.retired_at) return false;
    const fieldKey = normalize(field?.field_key);

    // Weight is entered once through dated Weight History records.
    if (fieldKey === "weight_kg") return false;

    // Preserve this legacy Pig definition in Admin Settings while keeping it
    // out of operational Add/Edit Animal forms.
    const isPig = normalize(species?.name) === "pig";
    const isDawe = fieldKey === "eq" && normalize(field?.label) === "dawe";
    return !(isPig && isDawe);
}
